import React from 'react'

import './google-button.css';

const GoogleButton = ({ onClick, logo }) => {
  return (
    <button onClick={onClick} className="google-button">
      <div className="button-content">
        <div className="logo-box">
          <img className="google-logo" src={logo}/>
        </div>
        <p className="google-text">
          Sign in with Google
        </p>
      </div>
    </button>
  )
}

export default GoogleButton


// WEBPACK FOOTER //
// ./src/components/GoogleButton/index.js